import { headers as defaultHeaders } from '@/config/axios';
import axiosRequest from '.';

const getUploadedFiles = async (data = {}) => axiosRequest({
  url: '/v1/uploadFile/getAll',
  method: 'POST',
  data,
  headers: defaultHeaders,
});

export { getUploadedFiles };
